import ReportKindCheckboxes from '../ReportFilterFields/ReportKindCheckboxes';
import ReportVatCheckboxes from '../ReportFilterFields/ReportVatCheckboxes';

const OffReportObjectsFilterForm = ({ showSales }: { showSales: boolean }) => (
    <>
        <ReportKindCheckboxes showSales={showSales} />
        <ReportVatCheckboxes />
    </>
);

export default OffReportObjectsFilterForm;
